import React, { useState } from "react";
import { AscImageSource, getImageSource } from "@ascendnow/shared";
import PlaceHolderImage from "../../assets/images/place-holder-image.svg";

export interface AscImageProps
  extends Omit<
    React.DetailedHTMLProps<
      React.ImgHTMLAttributes<HTMLImageElement>,
      HTMLImageElement
    >,
    "src"
  > {
  fallbackImageUrl?: AscImageSource;
  className?: string;
  src: AscImageSource;
}

const MAX_TRIES = 5;

export default function AscImage({
  fallbackImageUrl = PlaceHolderImage,
  className,
  src,
  ...rest
}: AscImageProps) {
  const [tries, setTries] = useState(0);

  function handleError(e: React.SyntheticEvent<HTMLImageElement, Event>) {
    const target: any = e.target;

    if (MAX_TRIES <= tries) {
      target.src = PlaceHolderImage;
      return;
    }

    setTries(tries + 1);

    if (target?.src?.includes(getImageSource(fallbackImageUrl))) {
      return;
    }
    target.src = getImageSource(fallbackImageUrl);
  }

  return (
    <img
      className={className}
      src={getImageSource(src || fallbackImageUrl)}
      onError={handleError}
      {...rest}
    />
  );
}
